"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readFile = void 0;

//
//  toolkit/fs.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 12/12/20.
//  Copyright © 2020-present ContextLogic Inc. All rights reserved.
//
var readFile = function readFile(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();

    reader.onload = function () {
      if (reader.result == null) {
        reject();
      } else {
        var blob = new Blob([reader.result.toString()], {
          type: file.type
        });
        resolve(blob);
      }
    };

    reader.onerror = function () {
      reject();
    };

    reader.readAsText(file);
  });
};

exports.readFile = readFile;